import { useAnyPlayerActive } from '@/hooks/media/useAnyPlayerActive';
import { useRouterEvents } from '@/hooks/navigation/useRouterEvents';
import { useMemo } from 'react';
import { Toaster as SonnerToaster } from 'sonner';
import { BOARDS_POPUP_CLOSE_DELAY_MS, BOARDS_TOASTER_ID } from './constants';
import { useBoardsContext } from './context-provider';
export const BoardsToaster = () => {
  const playerIsOpen = useAnyPlayerActive();
  const {
    dismissAllOpenToasts
  } = useBoardsContext();
  useRouterEvents({
    type: 'routeChangeComplete',
    handler: dismissAllOpenToasts
  });
  const offsetBottom = useMemo(() => playerIsOpen ? '5.5rem' : undefined, [playerIsOpen]);
  return <SonnerToaster expand={false} id={BOARDS_TOASTER_ID} mobileOffset={{
    bottom: offsetBottom
  }} offset={{
    bottom: offsetBottom
  }} position="bottom-center" swipeDirections={['left', 'right', 'bottom']} toastOptions={{
    duration: BOARDS_POPUP_CLOSE_DELAY_MS / 2,
    toasterId: BOARDS_TOASTER_ID
  }} visibleToasts={1} data-sentry-element="SonnerToaster" data-sentry-component="BoardsToaster" data-sentry-source-file="toaster.tsx" />;
};